import { useMemo } from 'react';

import { useDealContext } from '../../../utils/context/DealContext.tsx';
import { TopMarketRequestsType } from '../constants.ts';
import { mapTopMarketRequestsEntries } from '../utils/mapToMarketRequestsEntries.ts';

export const useMapTopMarketRequestsData = () => {
  const { useDealForecast } = useDealContext();
  const {
    forecastState: { forecast },
  } = useDealForecast({ shallow: true });

  const tableData = useMemo(() => {
    const top_domains = mapTopMarketRequestsEntries(TopMarketRequestsType.DOMAINS, forecast);
    const top_bundles = mapTopMarketRequestsEntries(TopMarketRequestsType.BUNDLES, forecast);

    return {
      top_bundles,
      top_domains,
    };
  }, [forecast]);

  return {
    tableData,
  };
};
